import type { NotificationHistory } from './notification-history.type.ts';
export interface NotificationHistoryExtension extends NotificationHistory {}
export class NotificationHistoryExtension {
  /**
   * Whether this notification has been opened at least once
   */
  get isOpened(): boolean {
    return this.firstOpenedAt !== null;
  }
}

const Registration = {
  kind: 'object',
  name: 'notification-history',
  features: NotificationHistoryExtension,
};
export default Registration;
